<template>
	<div class="view-body">
		<el-carousel arrow="always" ref="carousel" indicator-position="none" height="400px" class="banner-carousel" :interval="3000" :autoplay="true">
			<el-carousel-item v-for="( item , index ) in data" :key='index'>
				<div class="carousel-img">
					<w-image :src="item.ru_url"></w-image>
				</div>
			</el-carousel-item>
		</el-carousel>
	</div>
</template>

<script>
export default {
	name: 'certificateView',
	props: {
		data: Array
	}
}
</script>

<style lang="stylus" scoped>
.view-body {
	text-align: center
	height:400px
	.banner-carousel {
		margin:0 auto
		width:600px
		.carousel-img {
			margin:0 auto
			width:400px
			height:400px
			position: relative
			img {
				position: absolute
				max-height: 400px
				max-width: 400px
				top: 50%
				left: 50%
				transform: translate(-50%, -50%)
			}
		}
	}
}
</style>
